import * as actions from './slice'
import { stackAlert } from '../toast/helpers'

export const getQuizResults = {
  eventName: 'quizSearch',
  onSuccess: {
    action: actions.setResults,
    redux: true
  },
  onError: {
    action: stackAlert('Unable to get quiz results', 'error'),
    redux: true
  }
}
